export const ALGOLIA_ID = '987TN9L496';
export const ALGOLIA_KEY = '1ca9614b91f6f27efefc8cc5c976bee6';
export const ALGOLIA_PREST_IDX = 'pg_posts_kf_gem_prestazione';